export default __webpack_public_path__ + "static/media/G1ESS_150.af53ae43.jpg";